<!-- Invalid handler for event “click“: got undefined  @click="formData.xxx" 是 formData.xxx 报的错-->
<!-- 选商定价 有操作 -->
<template>
  <div class="choose-business-price container">
    <e-process :process-data="processData" :is-active="activeIndex"></e-process>
    <!--程序报错，暂时注释掉       :rules="formDataRules"-->
    <el-form ref="formDom" :model="formData" class="form-content" size="small">
      <!-- 基本信息 -->
      <div class="commodity-list">
        <div class="title">基本信息</div>
        <div class="enquiry-form">
          <el-row>
            <el-col :span="12">
              <el-form-item label-width="142px" label="询价单名称：" prop="enquiryName">
                <span>{{ formData.enquiryName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label-width="142px" label="询价类型：" prop="enquiryType">
                <span>
                  {{ formData.enquiryType === 0 ? '定向询价' : formData.enquiryType === 1 ? '公开询价' : '' }}
                </span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label-width="142px" label="报价开始时间：" prop="releaseTime">
                <span>{{ formData.releaseTime }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label-width="142px" label="报价截止时间：" prop="quotationDeadline">
                <span>{{ formData.quotationDeadline }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label-width="142px" label="结算方式：" prop="isDoC">
                <span>
                  {{ formData.isDoC != undefined ? (formData.isDoC === 1 ? '货到付款' : '款到发货') : '' }}
                </span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label-width="142px" label="配送方式：" prop="shipmentType">
                <span>{{ formatShipmentType(formData.shipmentType) }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label-width="142px" label="是否公示：" prop="whetherPublic">
                <el-radio-group v-model="formData.whetherPublic" disabled>
                  <el-radio :label="0">是</el-radio>
                  <el-radio :label="1">否</el-radio>
                  <!-- <el-tooltip class="right-icon" style="left: 124px" effect="dark" placement="top">
                    <div slot="content">
                      <p>是否把询价结果公示在平台上</p>
                    </div>
                    <div class="icon">?</div>
                  </el-tooltip> -->
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </div>
      <!-- 报价商品分配 -->
      <div v-if="isChoice" class="commodity-list">
        <div class="title">报价商品分配</div>
        <div class="commodity-content">
          <div class="search-box">
            <el-form ref="listQuery" :model="listQuery" size="small" class="search-form" @submit.native.prevent>
              <el-form-item label="供应商名称筛选：" label-width="130px" prop="">
                <el-input
                  v-model="listQuery.supplierCompany"
                  placeholder="供应商名称筛选"
                  @keyup.enter.native="handleSearch()"
                ></el-input>
              </el-form-item>
              <el-form-item label-width="30px">
                <div class="search-btn">
                  <div class="btn default-btn" @click="sort">
                    总价排序 {{ listQuery.orderByRule === 0 ? '↓' : '↑' }}
                  </div>
                  <div class="btn reset-btn" size="small" @click="handleReset">重置</div>
                  <div class="btn submit-btn" size="small" @click="handleSearch">查询</div>
                  <div
                    v-if="isCompareBtn && formData.createSource !== 2"
                    class="btn submit-btn price-btn"
                    size="small"
                    style="position: relative; right: -50px; top: 0"
                    @click="handlePrint"
                  >
                    报价对比表
                  </div>
                  <div
                    v-if="formData.createSource !== 2"
                    class="btn submit-btn price-btn"
                    size="small"
                    style="position: relative; right: -50px; top: 0"
                    @click="exportSupplierOffer"
                  >
                    导出报价明细
                  </div>
                  <div
                    v-if="formData.createSource !== 2"
                    class="btn submit-btn"
                    size="small"
                    style="position: relative; right: -50px; top: 0"
                    @click="goHistory"
                  >
                    历史报价对比
                  </div>
                </div>
                <!-- <el-button @click="handleSearch">查询</el-button>
          <el-button type="primary" @click="handleReset">重置</el-button> -->
              </el-form-item>
            </el-form>
          </div>
          <!-- table -->
          <div class="table-content">
            <el-table
              :data="tableData"
              border
              max-height="455"
              style="width: 100%"
              :header-cell-style="{ background: '#F5F5F5' }"
              size="small"
              current-row-key="index"
            >
              <el-table-column label="选择" width="50px" align="center">
                <!-- enquiryStatus: 5 询价完成
                    0: '待报价',
                    1: '已报价', 1
                    2: '已选入',
                    3: '未选入',
                    4: '已过期', 4
                    5: '作废',
                    6: '磋商中', 6
                   -->
                <template slot-scope="scope">
                  <el-radio
                    v-model="currentRow"
                    :disabled="
                      scope.row.offerStatus !== 1 && scope.row.offerStatus !== 4 && scope.row.offerStatus !== 6
                    "
                    :label="scope.row.supplierCompanyId"
                    @change.native="getCurrentRow(scope.row)"
                  ></el-radio>
                </template>
              </el-table-column>
              <el-table-column
                label="供应商名称"
                min-width="220"
                align="center"
                prop="supplierCompany"
              ></el-table-column>
              <el-table-column label="报价总价(元)" min-width="120" align="center" prop="offerAmount"></el-table-column>
              <el-table-column label="报价状态" min-width="110" align="center">
                <template #default="scope">
                  <span>
                    {{ offerStatusEN(scope.row.offerStatus) }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                label="报价有效期"
                min-width="150"
                align="center"
                prop="quotationValidity"
              ></el-table-column>
              <el-table-column label="报价时间" min-width="150" prop="createTime" align="center"></el-table-column>
              <el-table-column label="联系人" min-width="180" align="center" prop="offerRealName"></el-table-column>
              <el-table-column label="联系方式" min-width="110" align="center" prop="offerMobile"></el-table-column>
              <el-table-column prop="offerEmail" label="邮箱" min-width="180" align="center"></el-table-column>
              <el-table-column
                :key="2"
                prop="scoreAll"
                label="易派客标准指数"
                min-width="130"
                align="center"
              ></el-table-column>
              <el-table-column :key="3" prop="value" label="产品质量评价" width="100px" align="center">
                <template #default="scope">
                  <span class="add-sup" @click="companyDetail(scope.row.supplierCompanyId)">查看详情</span>
                </template>
              </el-table-column>

              <el-table-column
                :key="4"
                prop="creditGrade"
                label="法人信用认证"
                width="100px"
                align="center"
              ></el-table-column>

              <el-table-column :key="5" prop="compliance" label="履约动态考评" width="150px" align="center">
                <template #default="scope">
                  <el-rate v-model="scope.row.compliance / 5" disabled text-color="#ee9900"></el-rate>
                </template>
              </el-table-column>

              <el-table-column :key="6" prop="innovationEvaluate" label="市场业绩表现" width="150px" align="center">
                <template #default="scope">
                  <el-rate v-model="scope.row.innovationEvaluate" disabled text-color="#ff9900"></el-rate>
                </template>
              </el-table-column>

              <el-table-column label="附件" width="220px" align="center">
                <template slot-scope="scope">
                  <div>
                    <div
                      v-for="item of scope.row.supplierOfferAttachmentList"
                      :key="item.attachmentUrl"
                      class="table-handle-btn"
                      @click="
                        downloadFile({
                          fileName: item.attachmentName,
                          fileUrl: item.attachmentUrl,
                        })
                      "
                    >
                      {{ dealAttachmentName(item.attachmentName) }}
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="180px" align="center" fixed="right">
                <template slot-scope="scope">
                  <span
                    v-if="scope.row.offerStatus !== 0"
                    class="table-handle-btn"
                    @click="openDetailDia(scope.$index, scope.row)"
                  >
                    查看详情
                  </span>

                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="询价磋商是采购商、供应商双方对报价进行反复协商，最终达成一致的过程。"
                    placement="top-end"
                  >
                    <!-- -->
                    <span
                      v-if="scope.row.isCanConsult === 1 || scope.row.offerStatus === 4"
                      class="table-handle-btn"
                      @click="openNegotiationDialog(scope.row)"
                    >
                      发起磋商
                    </span>
                  </el-tooltip>
                  <span v-if="scope.row.isShowConsultRecord === 1" class="table-handle-btn" @click="goUrl(scope.row)">
                    磋商记录
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <!-- 供应商信息 -->
      <div class="commodity-list" style="margin-top: 10px">
        <div class="title">个人信息</div>
        <div class="enquiry-form">
          <el-row>
            <el-col :span="24">
              <el-form-item label-width="142px" label="期望到货日期：" prop="arrivalTime">
                <span>{{ formData.arrivalTime }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label-width="142px" label="联系人：" prop="realName">
                <span>{{ formData.realName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label-width="142px" label="联系方式：" prop="mobile">
                <span>{{ formData.mobile }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label-width="142px" label="邮箱：" prop="email">
                <span>{{ formData.email }}</span>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item label-width="142px" label="收货地址：" prop="address">
                <span>{{ formData.address }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label-width="142px" label="备注：" prop="address">
                <span>{{ formData.enquiryRemark }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label-width="142px" label="附件：" prop="address">
                <span
                  v-for="item of enquiryAttachmentUrlShow"
                  :key="item.fileUrl"
                  class="file-name"
                  @click="downloadFile(item)"
                >
                  {{ dealAttachmentName(item.fileName) }}
                </span>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="commodity-list" style="margin-top: 10px">
        <div class="title">备注及附件信息</div>
        <div class="enquiry-form">
          <el-row>
            <el-col :span="24">
              <el-form-item label-width="142px" label="备注：" prop="arrivalTime">
                <el-input
                  v-model="formData.selectivePricingRemark"
                  type="textarea"
                  maxlength="300"
                  :show-word-limit="true"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label-width="142px" label="附件：">
                <el-upload
                  ref="upload"
                  class="upload-demo"
                  :action="uploadUrl"
                  :headers="header"
                  :on-remove="handleRemove"
                  :before-upload="handleBeforeUpload"
                  :on-success="handleSuccess"
                  :on-exceed="() => $message.warning('最多上传5个文件')"
                  :limit="5"
                  :file-list="selectivePricingAttachmentAOList"
                  :show-file-list="true"
                >
                  <el-button type="primary">点击选择文件</el-button>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-form>

    <!-- 审批流程设置 -->
    <div class="commodity-list">
      <div class="title">审批流程设置</div>
      <div class="enquiry-form approve-wrapper">
        <div class="approve-tip">
          <img src="@/assets/img/approval/fqsp-grey.png" alt="" />
          选商定价审批
        </div>
        <div class="left">
          <div :class="{ 'margin-l8': !setPriceSwitch }">
            <div v-if="setPriceAuthFlag && !setPriceSwitch" class="no-info">
              <div class="choose-audit">
                <div class="choose-audit-tip">
                  <img src="@/assets/img/approval/gray-mark.png" alt="" />
                  <span class="gray-color">贵企业未启用审批流程，无需选择此项。</span>
                </div>
                <div v-if="setPriceAuthFlag" class="choose-btn" @click="toSetApprove">配置审批流</div>
              </div>
            </div>
            <div v-else-if="!setPriceAuthFlag && setPriceSwitch && setPriceApprovalList.length === 0" class="no-info">
              <div class="choose-audit">
                <div class="choose-audit-tip">
                  <img src="@/assets/img/approval/exclamation-mark.png" alt="" />
                  <span>贵企业尚未配置审批流，请联系管理员进行配置。</span>
                </div>
              </div>
            </div>
            <div v-else-if="setPriceSwitch" class="no-info">
              <div v-if="setPriceApprovalItem.auditName">
                {{ setPriceApprovalItem.auditName }}
              </div>
              <div v-else class="choose-audit">
                <div class="choose-audit-tip">
                  <img src="@/assets/img/approval/exclamation-mark.png" alt="" />
                  请选择审批流程
                </div>
              </div>
              <div class="choose-btn" @click="choiceAudit">选择审批流程</div>
            </div>
            <div v-else class="no-info">
              <div style="display: flex; align-items: center">
                <img src="@/assets/img/approval/gray-mark.png" alt="" />
                <span class="gray-color">贵企业未启用审批流程，无需选择此项。</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="formData.enquiryStatus !== 5" class="warning-content">
      <span>
        温馨提示：点击【完成并通知】后，不可更改中选供应商，供应商确认中选通知后，您可根据中选报价信息生成订单
      </span>
    </div>
    <div class="handle-button">
      <div class="btn back-btn" @click="toBack(null)">< 返回</div>
      <div class="right-btn">
        <div v-if="formData.enquiryStatus !== 5" class="btn submit-btn" @click="enquiryFinish">
          {{ createMode === '5' ? '确认并生成订单' : '完成并通知' }}
        </div>
        <!-- <div
          v-if="formData.enquiryStatus === 5"
          class="btn submit-btn"
          @click="goOrder"
        >
          根据已选商品生成订单
        </div> -->
        <div
          v-if="isDelayBtn && formData.createSource !== 2"
          class="btn submit-btn"
          style="margin-left: 20px"
          @click="openDelayDialog"
        >
          查看延时记录
        </div>
      </div>
    </div>

    <!-- 发起磋商 弹窗 -->
    <EDialog
      v-if="negotiationVisible"
      popup-width="880px"
      :dialog-title="'发起磋商'"
      :center-dialog-visible="negotiationVisible"
      :destroy-close="true"
      :modal-append-to-body="false"
      @updateVisible="closeDia('negotiationVisible')"
      @resetPopupData="closeDia('negotiationVisible')"
      @submitPopupData="handleNegotiation('negotiationVisible')"
    >
      <div class="prompt-modal-content">
        <el-form
          ref="negotiationForm"
          :model="negotiationForm"
          :rules="negotiationRules"
          label-width="140px"
          class="demo-ruleForm"
        >
          <el-form-item label="供应商名称:" prop="supplierCompany">
            <span>{{ negotiationForm.supplierCompany }}</span>
          </el-form-item>
          <el-form-item label="磋商类型:" prop="supplierCompany">
            <el-radio-group v-model="negotiationForm.consultationType" @change="changeRadio">
              <el-radio :label="0">供应商重新报价</el-radio>
              <el-radio :label="1">采购商填写报价</el-radio>
            </el-radio-group>
            <el-tooltip class="right-icon" effect="dark" placement="top">
              <div slot="content">
                <p>供应商重新报价：发起磋商后，供应商重新报价。</p>
                <p>采购商填写报价：采购商填写意向价格，发起磋商，供应商确认。</p>
              </div>
              <div class="icon">?</div>
            </el-tooltip>
          </el-form-item>
          <el-form-item label="磋商截至日期:" prop="consultDeadline">
            <el-date-picker
              v-model="negotiationForm.consultDeadline"
              type="datetime"
              placeholder="选择日期时间"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="timestamp"
              :picker-options="pickerReleaseTimeDatew"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="备注信息:" prop="consultRemark">
            <el-input
              v-model="negotiationForm.consultRemark"
              type="textarea"
              maxlength="300"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-form>
        <div v-if="negotiationForm.consultationType === 1">
          <ETableList index-show :table-data="purchaseTableData" :table-label="purchaseTableLabel">
            <template #price="{ scope: { row } }">
              <el-input
                v-model.trim="row.price"
                maxlength="12"
                min="0"
                oninput="value=value.replace(/[^0-9.]/g,'')"
                style="width: 100%"
                @change="validatePrice(row)"
              ></el-input>
            </template>
            <template #totalPrice="{ scope: { row } }">
              <span>{{ cacu(row) }}</span>
            </template>
          </ETableList>
          <div class="total-price">
            含税总金额：
            <span>{{ `¥${totalPrice}` }}</span>
          </div>
        </div>
      </div>
    </EDialog>

    <!-- 查看详情dialog -->
    <supplier-detail
      :supplier-detail-visible.sync="supplierDetailVis"
      :params="detailParams"
      :offer-amount="offerAmount"
    />
    <!-- 选择审批流弹窗 -->
    <approve
      :show-audit-mask.sync="showAuditMask"
      :approval-list="setPriceApprovalList"
      @getApprovalChain="getApprovalChain"
    />

    <!-- 选择审批流弹窗 -->
    <approve
      :show-audit-mask.sync="showAuditMask"
      :approval-list="setPriceApprovalList"
      @getApprovalChain="getApprovalChain"
    />

    <el-dialog width="36%" title="产品质量评价详情" :visible.sync="detailVisible" append-to-body>
      <el-table
        v-loading="detailLoading"
        :data="detailTableData"
        height="252"
        border
        size="small"
        style="width: 100%"
        :header-cell-style="{ background: '#F5F5F5' }"
      >
        <el-table-column prop="categoryDescription" label="商品类目" min-width="180" align="center"></el-table-column>
        <el-table-column
          prop="productEvaluate"
          label="产品质量评价分数"
          min-width="180"
          align="center"
        ></el-table-column>
      </el-table>
      <div class="pagination-box">
        <el-pagination
          :pager-count="5"
          layout="total, prev, pager, next"
          :current-page="detailQuery.pageNum"
          :total="detailTotal"
          :small="true"
          :page-size.sync="detailQuery.pageSize"
          @size-change="detailHandleSizeChange"
          @current-change="detailHandleCurrentChange"
        ></el-pagination>
      </div>
    </el-dialog>

    <delay-dialog
      dialog-title="延时记录"
      :dialog-visible.sync="dialogVisible"
      :table-label="tableLabel"
      :table-data="delayTableData"
    />
  </div>
</template>
<script>
import Api from '@/modules/projectA/api/enquiry/index';
import api from '@/modules/projectA/api/order';
import EProcess from '@/modules/projectA/components/common/e-process.vue';
import utils, { dealAttachmentName, calRoundNum } from '@/modules//projectA/utils/utils';
import { mallBaseUrl } from '@/modules/projectA/api/urlConfig';
import _ from 'lodash';
import { epecToken } from '@/modules/projectA/utils/globalData';
import { yyhtUrl } from '@/modules/projectA/api/config';
import ETableList from '@/modules/projectA/components/common/e-table-list';
import EDialog from '@/modules/projectA/components/common/e-dialog.vue';
import Approve from '../components/approveDia.vue';
import SupplierDetail from '../components/supplierDetail.vue';
import DelayDialog from '../components/delayDialog';

import { negotiationRemark } from './componentsData';

export default {
  components: {
    SupplierDetail,
    EProcess,
    Approve,
    DelayDialog,
    ETableList,
    EDialog,
  },
  mixins: [negotiationRemark],
  data() {
    const enquiryTypeObj = {
      0: '定向询价',
      1: '公开询价',
    };
    return {
      selectivePricingAttachmentList: [],
      dialogVisible: false,
      tableLabel: [
        {
          label: '操作人',
          param: 'createMemberName',
          align: 'center',
          width: '200',
        },
        {
          label: '延时发起时间',
          param: 'createTime',
          align: 'center',
          width: '200',
        },
        {
          label: '报价截止时间',
          param: 'quotationDeadlineStr',
          align: 'center',
          width: '200',
        },
        {
          label: '延时原因',
          param: 'remark',
          align: 'center',
          width: '420',
        },
      ],
      delayTableData: [],
      uploadUrl: api.enquiryPrice_fileUpload,
      header: epecToken,
      selectivePricingAttachmentAOList: [],
      detailTotal: 0,
      detailQuery: {
        pageNum: 1,
        pageSize: 10,
        companyId: -1,
      },
      detailVisible: false, // 产品质量评价 查看详情 弹框
      detailTableData: [], // 产品质量评价 查看详情 弹框 详情列表参数
      detailLoading: false,
      offerAmount: 0,
      detailParams: {},
      activeIndex: 3,
      processData: [
        {
          itemName: '发布询价需求',
          title: '发布询价需求',
          tip: '',
          description: '',
          icon: '',
        },
        {
          itemName: '供应企业报价',
          title: '供应企业报价',
          tip: '',
          description: '',
          icon: '',
        },
        {
          itemName: '选商定价',
          title: '选商定价',
          tip: '',
          description: '',
          icon: '',
        },
        {
          itemName: '结果公示',
          title: '结果公示',
          tip: '',
          description: '',
          icon: '',
        },
      ],
      supplierDetailVis: false,
      currentRow: -1,
      listQuery: {
        offerOrNot: 1,
        pageNum: 1,
        pageSize: 100,
        enquiryId: '',
        supplierCompany: '',
        orderByRule: 0, // 0 正序; 1倒序
      },
      enquiryTypeObj,
      // 列表验证+列表数据
      formData: {
        brandNameX: '',
        enquiryType: 1,
        enquiryStatus: -1,
      },
      tableData: [],
      paramsRow: {},
      btnFlag: true,
      enquiryAttachmentUrlShow: [],
      ifIntegrated: false,

      negotiationVisible: false,
      negotiationForm: {
        consultRemark: '',
        consultDeadline: '',
        supplierCompany: '',
        consultationType: 0,
      },
      negotiationRules: {
        consultDeadline: [{ required: true, message: '请选择时间', trigger: 'change' }],
      },
      pickerReleaseTimeDate: {
        disabledDate: (time) => {
          return time.getTime() < Date.now();
        },
      },
      setPriceSwitch: false, // 选商定价的开关
      setPriceApprovalList: [], // 选商定价的审批流
      setPriceAuthFlag: true, // 选商定价的权限
      // 选商定价 选中项
      setPriceApprovalItem: {
        auditId: null,
        auditName: '',
      },
      showAuditMask: false,

      pickerReleaseTimeDatew: {
        disabledDate: (time) => {
          return time.getTime() <= Date.now() - 8.64e7;
        },
      },
      // createMode '创建类型，0：用户创建；1：第三方集成；2：一体化' 3: 采购需求 4:采购计划, 5易应急询比价
      createMode: '',
      isChoice: false,
      enquiryStatus: -1,
    };
  },
  computed: {
    // 2、待报价、待揭示、已揭示、询价完成、生成订单、询价作废、询价过期、选商定价待审批  状态增加查看延时记录；
    isDelayBtn() {
      const enquiryStatusList = [2, 3, 4, 5, 7, 8, 10, 12];
      return enquiryStatusList.includes(this.enquiryStatus);
    },
    // 1、已揭示、询价完成、生成订单状态也可以查看供应商报价对比表。
    isCompareBtn() {
      const enquiryStatusList = [4, 5, 7];
      return enquiryStatusList.includes(this.enquiryStatus);
    },
    companyId() {
      return this.$store.state.USERINFO.companyId;
    },
  },
  watch: {
    isChoice(newVal) {
      if (newVal) {
        const { enquiryId } = this.$route.query;
        this.getCenterList({
          enquiryId: Number(enquiryId),
          pageNum: 1,
          pageSize: 100,
          orderByRule: 0,
        });
      }
    },
  },
  mounted() {
    const { enquiryId, createMode = '' } = this.$route.query;
    this.createMode = createMode; //
    this.ifIntegrated = createMode === '2';
    this.listQuery.enquiryId = Number(enquiryId);

    this.getDetailInfo({ enquiryId: Number(enquiryId) });
    this.checkAuth();
    this.queryApprovalProcessSwitch();
  },
  methods: {
    async getDialogList() {
      const params = {
        pageNum: 1,
        pageSize: 1000,
        enquiryId: this.listQuery.enquiryId,
        supplierOfferId: this.negotiationForm.supplierOfferId,
      };
      await Api.querySupplierOfferDetailPage(params).then((res) => {
        if (res.code === '200') {
          const {
            data: { records = [] },
          } = res;
          this.purchaseTableData = [...records];
        }
      });
    },
    changeRadio(val) {
      if (val === 1) {
        this.getDialogList();
      }
    },

    // 计算
    validatePrice(row) {
      const isPrice = row.price;
      if (isPrice === '') {
        this.$message.warning('请输入正确报价单价！');
        return;
      }
      row.price = Number(row.price).toFixed(2);
    },
    // 采购商-查询询价单详情
    async getDetailInfo(params) {
      this.detailLoading = true;
      await Api.queryEnquiryDetailByEnquiryId(params).then((res) => {
        this.detailLoading = false;
        if (res.code === '200') {
          const { data } = res;
          this.enquiryStatus = data.enquiryStatus;
          console.log(this.companyId, data.purchaseCompanyId, 'companyId');
          console.log(data.viewOfferCount, 'viewOfferCount');
          console.log(data.enquiryStatus, 'enquiryStatus');
          this.isChoice =
            data.purchaseCompanyId === this.companyId && data.viewOfferCount >= 1 && data.enquiryStatus === 4;

          console.log(this.isChoice, 'this.isChoice');

          this.formData = data;

          this.getTableList(data.purchaseCompanyId);

          // 展示转换
          if (data.enquiryAttachmentList?.length) {
            const enquiryAttachmentUrlShow = data.enquiryAttachmentList;
            this.enquiryAttachmentUrlShow = enquiryAttachmentUrlShow.map((item) => ({
              fileUrl: item.attachmentUrl,
              fileName: item.attachmentName,
            }));
          }
          this.selectivePricingAttachmentAOList = data.selectivePricingAttachmentList.map((item) => ({
            fileUrl: item.attachmentUrl,
            fileName: item.attachmentName,
            name: item.attachmentName,
          }));
        }
      });
    },
    async getCenterList(params) {
      // queryOfferListByPage 中间选商列表接口
      await Api.queryOfferListByPage(params).then((res) => {
        this.detailLoading = false;
        if (res.code === '200') {
          // this.formData =
          this.tableData = res.data?.records;
          this.tableData = this.tableData.filter((item) => item.offerStatus !== 5);
          this.tableData.forEach((item) => {
            if (item.innovationEvaluate) {
              item.innovationEvaluate = this.handleInnovationEvaluate(item.innovationEvaluate);
            }
          });
          const { createMode = '' } = this.$route.query;
          if (createMode === '5') {
            // 默认选中第一条
            this.currentRow = this.tableData[0].supplierCompanyId;
            this.getCurrentRow(this.tableData[0]);
          }
        }
      });
    },
    handlePrint() {
      const { enquiryId } = this.$route.query;
      const { href } = this.$router.resolve({
        path: '/enquiryOrder',
        query: { enquiryId },
      });
      window.open(href, '_blank');
    },
    // 延时记录
    async getTableList(purchaseCompanyId) {
      const { enquiryId: enquiryOfferId } = this.$route.query;
      const params = {
        changeTypeList: [2],
        enquiryOfferId,
        companyId: purchaseCompanyId,
      };
      const result = await Api.queryEnquiryOfferChangeList(params);
      if (result.code === '200') {
        result.data.forEach((el) => {
          el.quotationDeadlineStr = JSON.parse(el.changeDataJson).quotationDeadlineStr;
        });
        this.delayTableData = [...result.data];
        console.log(this.delayTableData);
      }
    },
    openDelayDialog() {
      this.dialogVisible = true;
    },
    // 处理市场业绩
    handleInnovationEvaluate(score) {
      if (score >= 0 && score < 10) {
        return 1;
      }
      if (score >= 10 && score < 20) {
        return 2;
      }
      if (score >= 20 && score < 40) {
        return 3;
      }
      if (score >= 40 && score < 60) {
        return 4;
      }
      if (score >= 60) {
        return 5;
      }
    },
    detailHandleCurrentChange(val) {
      this.detailQuery.pageNum = val;
      this.getCompanyDetailList(this.detailQuery);
    },
    detailHandleSizeChange(val) {
      this.detailQuery.pageSize = val;
      this.detailQuery.pageNum = 1;
      this.getCompanyDetailList(this.detailQuery);
    },
    // 内层弹窗
    companyDetail(companyId) {
      this.detailQuery.companyId = companyId;
      this.detailVisible = true;
      this.getCompanyDetailList(this.detailQuery);
    },
    // 获取公司详情数据
    async getCompanyDetailList(params) {
      this.detailLoading = true;
      await Api.queryCompanyProductGradePage(params).then((res) => {
        this.detailLoading = false;
        if (res.code === '200') {
          const list = res.data?.records;
          this.detailTableData = [...list];
          this.detailTotal = res.data?.total;
        }
      });
    },
    // 内层弹窗
    companyDetail(companyId) {
      this.detailQuery.companyId = companyId;
      this.detailVisible = true;
      this.getCompanyDetailList(this.detailQuery);
    },
    // 配置审批流  https://uat-yyzx.epec.com/#/purchaseAudit
    toSetApprove() {
      window.open(`${yyhtUrl}/#/approveSetting`);
    },
    async checkAuth() {
      const resData = await Api.hasAuthCode({
        authCode: '/approveSetting',
      });
      if (resData.code == 200) {
        this.setPriceAuthFlag = resData.data;
      }
    },
    // 判断审批流的开关
    async queryApprovalProcessSwitch() {
      // 获取选商定价审批的权限
      const res = await Api.queryOrderAskPrice({});
      if (res.code == 200) {
        if (res.data) {
          this.setPriceSwitch = res.data.data === '41';
          if (this.setPriceSwitch) {
            this.getSetPriceApprovalList();
          }
        } else {
          this.setPriceSwitch = false;
        }
      }
    },
    // 获取选商定价审批信息
    async getSetPriceApprovalList() {
      const res = await Api.approveList({ auditTypeList: [4, 6] });
      if (res.code == 200) {
        this.setPriceApprovalList = res.data;
        if (res.data.length == 1) {
          this.setPriceApprovalItem = this.setPriceApprovalList[0];
        }
      }
    },
    dealAttachmentName,
    downloadFile(fileObj) {
      // 通过 url 下载文件并给文件重新起名字
      const downloadRes = async () => {
        const response = await fetch(fileObj.fileUrl); // 内容转变成blob地址
        const blob = await response.blob(); // 创建隐藏的可下载链接
        const objectUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = objectUrl;
        a.download = fileObj.fileName;
        a.click();
        a.remove();
      };
      downloadRes();
    },
    goHistory() {
      this.$router.push({
        path: '/emergencyEnquiry/enquiryManage/historyContrast',
        query: {
          enquiryId: this.listQuery.enquiryId,
        },
      });
    },
    goUrl(row) {
      const { enquiryId = '', supplierOfferId = '' } = row;
      this.$router.push({
        path: '/emergencyEnquiry/enquiryManage/negotiationRemark',
        query: {
          enquiryId,
          supplierOfferId,
        },
      });
    },
    offerStatusEN(offerStatus) {
      const offerStatusObj = {
        0: '待报价',
        1: '已报价',
        2: '已选入',
        3: '未选入',
        4: '过期',
        5: '作废',
        6: '磋商中',
      };
      return offerStatusObj[offerStatus];
    },
    sort() {
      this.listQuery.orderByRule = this.listQuery.orderByRule === 0 ? 1 : 0;
      if (this.isChoice) {
        this.getCenterList(this.listQuery);
      }
    },
    // 根据已选商品生成订单
    goOrder() {
      const { enquiryId } = this.paramsRow;
      const { createMode = '' } = this.$route.query;
      const enquiryOrder = createMode === '2' ? 'myPurchaseRequest' : 'enquiryOrder';
      window.open(
        `${mallBaseUrl}/order?enquiryId=${enquiryId}&flag=${enquiryOrder}&createMode=${createMode}`,
        '_blank'
      );
    },

    toBack(times) {
      if (times) {
        this.$router.push({
          path: '/emergencyEnquiry/enquiryManage',
          query: { t: times },
        });
      } else {
        this.$router.push({ path: '/emergencyEnquiry/enquiryManage' });
      }
    },
    // 询价完成
    async enquiryFinish() {
      console.log(this.formData, this.selectivePricingAttachmentAOList);
      if (this.currentRow === -1) {
        this.$message.warning('请选定供应商');
        return;
      }

      if (this.setPriceSwitch && !this.setPriceApprovalItem.auditId) {
        this.$message.warning('请选择审批流!');
        return;
      }
      const { enquiryId, supplierOfferId } = this.paramsRow;
      const params = {
        enquiryId,
        supplierOfferId,
        isSelectivePriceAudit: this.setPriceApprovalItem.auditId ? 1 : 0,
        selectivePriceAuditId: this.setPriceApprovalItem.auditId,
        selectivePricingRemark: this.formData.selectivePricingRemark,
        selectivePricingAttachmentAOList: this.selectivePricingAttachmentAOList.map((t) => ({
          attachmentName: t.name,
          attachmentUrl: t.url,
        })),
      };
      await Api.modifyOfferStatus(params).then((res) => {
        this.detailLoading = false;
        if (res.code === '200') {
          // 有选择审批流跳转到列表页
          if (this.setPriceApprovalItem.auditId) {
            this.$message.success('发起选商定价审批，审批通过后即询价完成。');
            this.$router.push({ path: '/emergencyEnquiry/enquiryManage' });
          } else {
            this.$message.success('询价完成');
            const { createMode } = this.$route.query;
            if (createMode === '5') {
              this.goOrder();
              return;
            }
            // this.getDetailInfo({ enquiryId: Number(enquiryId) });
            setTimeout(() => {
              let times = new Date();
              times = times.getTime();
              this.toBack(times);
            }, 1000);
          }
        }
      });
    },
    getApprovalChain(val) {
      this.setPriceApprovalItem = val;
    },
    closeDialog() {
      this.showAuditMask = false;
    },
    // 选择审批流程
    choiceAudit() {
      this.showAuditMask = true;
    },
    goBack() {
      this.$router.push({
        path: '/emergencyEnquiry/enquiryManage',
      });
    },

    openDetailDia(index, row) {
      const { supplierOfferId, enquiryId } = row;
      this.detailParams.enquiryId = enquiryId;
      this.detailParams.supplierOfferId = supplierOfferId;
      this.supplierDetailVis = true;
      this.offerAmount = row.offerAmount;
    },
    openNegotiationDialog(row) {
      const { supplierOfferId = '', supplierCompany = '' } = row;
      this.negotiationVisible = true;
      this.negotiationForm.supplierOfferId = supplierOfferId;
      this.negotiationForm.supplierCompany = supplierCompany;
      this.negotiationForm.consultationType = 0;
      this.purchaseTableData = [];
      // this.negotiationForm.consultDeadline = row.quotationValidity;
      this.formData.endTimeSelf = row.quotationValidity;
    },
    //
    handleNegotiation: _.debounce(function (type) {
      this.$refs.negotiationForm.validate(async (valid) => {
        if (valid) {
          if (this.negotiationForm.consultationType === 1) {
            for (let i = 0; i < this.purchaseTableData.length; i++) {
              const item = this.purchaseTableData[i];
              if (!item.price) {
                this.$message.warning('请填写报价');
                return;
              }
            }

            this.negotiationForm.offerAmount = this.totalPrice;
            this.negotiationForm.supplierOfferDetailList = this.purchaseTableData;
          }

          try {
            const { enquiryId = '' } = this.listQuery;

            const result = await Api.addSupplierOfferConsult({
              ...this.negotiationForm,
              enquiryId,
            });
            if (result.code === '200') {
              if (this.isChoice) {
                this.$message.success('磋商发起成功。');
                this.getCenterList(this.listQuery);
              }
            }
          } finally {
            this.closeDia(type);
          }
        } else {
          console.log('error submit!!');
        }
      });
    }, 500),
    closeDia(type) {
      this[type] = false;
      if (type === 'negotiationVisible') {
        this.$refs.negotiationForm.resetFields();
        console.log(this.negotiationForm, 'negotiationForm');
      }
    },
    getCurrentRow(row) {
      this.paramsRow = { ...row };
      console.log(this.paramsRow);
    },
    // 搜索
    handleSearch() {
      this.listQuery.pageNum = 1;
      if (this.isChoice) {
        this.getCenterList(this.listQuery);
      }
    },
    // 重置
    handleReset() {
      this.listQuery.supplierCompany = '';
      this.listQuery.pageNum = 1;
      if (this.isChoice) {
        this.getCenterList(this.listQuery);
      }
    },
    // 开课时期
    startClassChange(courseDay) {
      this.formData.quotationDeadline = courseDay || '';

      if (courseDay) {
        courseDay && this.endClassChange(courseDay + 13 * 24 * 3600 * 1000);
      }
    },
    // 节课时期
    endClassChange(endCourseDay) {
      this.formData.arrivalTime = endCourseDay || '';
    },
    // 概要导出
    exportSupplierOffer: _.debounce(async function () {
      const { enquiryId } = this.$route.query;
      const { supplierCompany = '' } = this.listQuery;
      this.exportFlag = true;
      const res = await Api.exportSupplierOffer({
        supplierCompany,
        enquiryId,
      });
      if (res.type == 'application/json') {
        utils.fileExportResponseError(res);
      } else {
        utils.downFile(res, '供应商报价明细表');
      }
    }),
    formatShipmentType(type) {
      let str = '';
      if (type === 1) {
        str = '卖家自行配送';
      } else if (type === 3) {
        str = '第三方物流';
      }
      return str;
    },
    handleBeforeUpload(file) {
      if (file.size / 1024 / 1024 > 30) {
        this.$message.warning('请上传小于30M的文件！');
        return false;
      }
      return true;
    },
    handleRemove(file, fileList) {
      this.selectivePricingAttachmentAOList = fileList;
    },
    handleSuccess(res, file) {
      this.selectivePricingAttachmentAOList.push({
        name: file.name,
        url: file.response.data.url,
      });
    },
  },
};
</script>
<style lang="scss">
.el-dialog {
  .el-dialog__body {
    padding: 10px;
    .pagination-box {
      text-align: center;
      margin-top: 10px;
      .el-pagination {
        button {
          height: 30px;
          color: #999;
        }
        .el-select {
          .el-input__inner {
            border-radius: 0;
            height: 30px;
          }
        }
        .el-input__inner {
          border-radius: 0;
          height: 30px;
          color: #999;
        }
        .el-select-dropdown__item,
        .el-pagination__jump,
        .el-pagination__total {
          height: 28px;
          line-height: 28px;
          color: #999;
          float: right;
        }
        .el-pager {
          li {
            border-radius: 0;
            border: 1px solid #d9d9d9;
            line-height: 28px;
            text-align: center;
            margin-left: 10px;
            width: 40px;
            height: 30px;
            color: #999;
            &:first-child {
              margin-left: 0;
            }
            &.active {
              background: #2587ff;
              border: none;
              color: #fff;
            }
          }
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.total-price {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
  span {
    color: #f0250f;
  }
}
.right-icon {
  display: inline-block;
  position: relative;
  left: 20px;
  bottom: 1px;
  width: 18px;
  height: 18px;
  line-height: 16px;
  text-align: center;
  border-radius: 50%;
  border: 1px solid #c5c5c5;
  font-size: 12px;
  color: #c5c5c5;
  cursor: pointer;
  &:hover {
    background: #c5c5c5;
    color: #fff;
  }
}
.choose-business-price {
  background: #fff;
  padding: 20px;
  ::v-deep .prompt-modal-content {
    .hint {
      height: 40px;
      line-height: 40px;
      background: #fffce8;
    }
  }
  ::v-deep .el-table__row .cell {
    .el-radio {
      .el-radio__label {
        display: none;
      }
    }
  }
  .add-sup {
    color: #0064c8;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
  .form-content {
    ::v-deep .el-select {
      width: 100%;
    }
    ::v-deep .el-date-editor.el-input {
      width: 100%;
      .el-input__inner {
        border-radius: 0;
      }
    }
    ::v-deep .el-input {
      .el-input__inner {
        border-radius: 0;
      }
    }
    .right-icon {
      /*  position: absolute;
      left: 236px;
      top: 7px; */
      width: 18px;
      height: 18px;
      line-height: 16px;
      text-align: center;
      border-radius: 50%;
      border: 1px solid #c5c5c5;
      font-size: 12px;
      color: #c5c5c5;
      cursor: pointer;
      &:hover {
        background: #c5c5c5;
        color: #fff;
      }
    }
  }
  .commodity-list {
    border: 1px solid #f5f5f5;
    &:last-child {
      margin-top: 10px;
    }
    .title {
      height: 40px;
      line-height: 40px;
      background: #f5f5f5;
      padding-left: 20px;
    }
    .commodity-content {
      padding: 10px;
      .search-box {
        .search-form {
          display: flex;
          align-items: center;
          background: #fff;
        }

        ::v-deep .el-form-item--small.el-form-item {
          margin-bottom: 10px;
          margin-right: 0px;
        }
        .search-btn {
          display: flex;
          flex-direction: row;
          justify-content: center;
          position: relative;

          .btn {
            min-width: 80px;
            text-align: center;
            height: 30px;
            line-height: 27px;
            padding: 0 10px;
            cursor: pointer;
          }

          .default-btn {
            background: #fff;
            border: 1px solid #dcdfe6;
            margin-right: 20px;
          }

          .reset-btn {
            background: #e8efff;
            border: 1px solid #2587ff;
            color: #2587ff;
            margin-right: 30px;
            line-height: 27px;
            &:hover,
            :active {
              background-color: #126edf;
              color: #fff;
            }
          }
          .submit-btn {
            background: #2587ff;
            border: 1px solid #2587ff;
            color: #ffffff;
            &:hover,
            :active {
              background-color: #126edf;
            }
            &.price-btn {
              margin-right: 10px;
            }
          }
        }
      }
      .set-type {
        line-height: 52px;
        i {
          font-size: 20px;
          cursor: pointer;
          &:hover {
            color: #2587ff;
          }
        }
      }
      .handle-btn {
        margin: 10px 0;
        .el-button {
          border-radius: 0;
        }
      }
      .table-content {
        ::v-deep .el-table th.must div:before {
          content: '*';
          color: #ff1818;
        }

        .edit-input {
          ::v-deep .el-input__inner {
            border-radius: 0;
          }
        }
      }
      .table-handle-btn {
        color: #0064c8;
        cursor: pointer;
        &:hover {
          text-decoration: underline;
        }
      }
    }
    .approve-wrapper {
      display: flex;
      justify-content: space-around;
      padding: 20px;
      align-items: center;
      height: 50px;
      .approve-tip {
        width: 600px;
        display: flex;
        img {
          width: 16px;
          height: 16px;
          margin: 4px 4px 0;
        }
      }
    }
    .enquiry-form {
      padding-top: 20px;
      ::v-deep .el-select {
        width: 100%;
      }
      ::v-deep .el-date-editor.el-input {
        width: 80%;
        .el-input__inner {
          border-radius: 0;
        }
      }
      ::v-deep .el-input {
        width: 80%;
        .el-input__inner {
          border-radius: 0;
        }
      }
      ::v-deep .el-textarea {
        width: 80%;
        .el-textarea__inner {
          border-radius: 0;
        }
      }

      .address-btn {
        color: #0064c8;
        text-decoration: underline;
        cursor: pointer;
      }
      .left {
        // @include flex(start,center,column);
        width: 100%;
        color: #333;
        font-size: 14px;
        line-height: 31px;
        margin: 5px 20px;

        .both-side {
          display: flex;
          justify-content: space-between;
          .receive-address {
            color: #2587ff;
            cursor: pointer;
            border-bottom: 1px solid transparent;
            &:hover {
              border-bottom: 1px solid #2587ff;
            }
          }
        }
        .margin-l8 {
          margin-left: -18px;
        }
        .break {
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .no-info {
          display: flex;
          align-items: center;
          justify-content: space-between;
          position: relative;
          .choose-btn {
            width: 120px;
            height: 30px;
            background: #2587ff;
            font-size: 14px;
            line-height: 30px;
            text-align: center;
            color: #ffffff;
            cursor: pointer;
          }
          .choose-audit {
            width: 100%;
            display: flex;
            justify-content: space-between;
            .choose-audit-tip {
              display: flex;
              align-items: center;
            }
            .choose-btn {
              width: 120px;
              height: 30px;
              background: #2587ff;
              font-size: 14px;
              line-height: 30px;
              text-align: center;
              color: #ffffff;
              cursor: pointer;
            }
          }
          /* div {
            display: flex;
            align-items: center;
            position: relative;
          } */

          .gray-color {
            color: #c5c5c5;
          }
          img {
            width: 18px;
            height: 18px;
            margin-right: 10px;
          }
        }
      }
      .right {
        .choose-btn {
          width: 120px;
          height: 30px;
          background: #2587ff;
          font-size: 14px;
          line-height: 30px;
          text-align: center;
          color: #ffffff;
          cursor: pointer;
        }
      }
    }
  }
  .handle-button {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    .back-btn {
      color: #333;
      border: 1px solid #dcdfe6;
    }
    .btn {
      min-width: 80px;
      text-align: center;
      height: 30px;
      line-height: 27px;
      padding: 0 10px;
      cursor: pointer;
    }
    .right-btn {
      display: flex;
    }
    .reset-btn {
      background: #e8efff;
      border: 1px solid #2587ff;
      color: #2587ff;
      margin-right: 30px;
      line-height: 27px;
      &:hover,
      :active {
        background-color: #126edf;
        color: #fff;
      }
    }
    .submit-btn {
      background: #2587ff;
      border: 1px solid #2587ff;
      color: #ffffff;
      &:hover,
      :active {
        background-color: #126edf;
      }
    }
  }
  .pagination {
    margin-top: 18px;
  }
  .warning-content {
    display: flex;
    align-items: center;
    line-height: 56px;
    background: #fffce8;
    padding-left: 10px;
    margin-top: 10px;
    &::before {
      content: '*';
      color: #f0250f;
    }
  }
}
</style>
